import React from "react";
import styles from "../styles";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          TREND AnyWARE® SOFTWARE END USER LICENCE AGREEMENT
        </span>

        <span className="lineBreak">
          BY CLICKING ON THE “ACCEPT” BUTTON BELOW YOU AGREE TO THE TERMS OF
          THIS EULA WHICH WILL BIND YOU
        </span>

        <span className="lineBreak">
          This End-User Licence Agreement, as it may be amended by us from time
          to time in accordance with section 12 (<b>EULA</b>), is a legally
          binding agreement between you (either an individual or a single
          entity) and TREND Networks Limited (<b>TREND</b>) for your access to
          and use of the TREND AnyWARE® software that accompanies this EULA and
          may include associated media, printed materials, “online" or
          electronic documentation, and Internet-based services (<b>Software</b>
          ). The Software enables you to interface with and access data from
          compatible TREND test equipment, devices and tools (<b>Tools</b>). The
          Software can be accessed using a web browser on any device or
          downloaded and installed onto a computer.
        </span>

        <span className="lineBreak">
          <b>IMPORTANT – PLEASE READ THE TERMS OF THIS EULA CAREFULLY.</b>
          IT CONTAINS IMPORTANT TERMS THAT AFFECT YOU AND YOUR USE OF THE
          SOFTWARE, AND NEEDS TO BE ASSESSED BY YOU AGAINST THE CURRENT VERSION
          OF THE EULA AS AND WHEN IT IS IMPLEMENTED. BY CREATING AN ACCOUNT,
          INSTALLING OR OTHERWISE ACCESSING OR USING THE SOFTWARE OR ANY PORTION
          THEREOF, YOU AGREE THAT YOU HAVE READ, UNDERSTOOD AND AGREE TO BE
          BOUND BY THE TERMS OF THIS EULA ON YOUR OWN BEHALF AND, AS APPLICABLE,
          ON BEHALF OF THE COMPANY OR ENTITY WHICH EMPLOYS YOU OR WHICH YOU
          REPRESENT. IF YOU DO NOT AGREE, DO NOT ACCESS, INSTALL, COPY, OR USE
          THE SOFTWARE AND SHOULD YOU NOT AGREE TO ANY AMENDMENT TO THIS EULA
          YOU SHALL NO LONGER HAVE ANY RIGHT OR LICENCE TO ACCESS OR USE THE
          SOFTWARE AND YOU SHALL IMMEDIATELY UNINSTALL AND/OR CEASE ANY ACCESS
          OR USE OF THE SOFTWARE.
        </span>

        <span className="lineBreak">
          YOU REPRESENT AND WARRANT THAT YOU ARE ENTERING INTO THIS EULA IN THE
          COURSE OF CARRYING ON YOUR BUSINESS OR FOR BUSINESS PURPOSES (AND NOT
          AS A CONSUMER). HOWEVER IN THE EVENT THAT ANY CONSUMER LAWS APPLY
          UNDER APPLICABLE LAW, THIS EULA DOES NOT AFFECT OR PREJUDICE ANY
          STATUTORY CONSUMER RIGHTS YOU MAY HAVE UNDER APPLICABLE LAW. IF YOU
          ARE ENTERING INTO THIS EULA ON BEHALF OF A COMPANY OR OTHER LEGAL
          ENTITY, YOU REPRESENT AND WARRANT THAT YOU HAVE THE AUTHORITY TO BIND
          SUCH COMPANY OR ENTITY TO THE TERMS OF THIS EULA, IN WHICH CASE THE
          TERMS "YOU" OR "YOUR" SHALL ALSO REFER TO THE COMPANY OR ENTITY WHICH
          YOU REPRESENT OR ARE EMPLOYED BY, ITS AFFILIATES AND EACH OF THEIR
          DIRECTORS, OFFICERS, EMPLOYEES, AGENTS AND REPRESENTATIVES.
        </span>

        <ol>
          <li>
            <b>USE OF SOFTWARE</b>
            <ol>
              <li>
                Subject to your compliance with the terms of this EULA, TREND
                grants you a non-exclusive, non-transferable, non-sublicensable,
                revocable, limited right and licence to download, install,
                activate, access or otherwise use object code versions of the
                Software on a device owned or controlled by you, solely and
                exclusively for your internal operations, as permitted by this
                EULA.
              </li>
              <li>
                You may permit a third party and/or users within your company or
                organisation (Permitted Users) the right to access and use the
                Software in the regular course of their work if such use is
                solely: (i) on your behalf; (ii) for your internal operations;
                and (iii) in compliance with this EULA. You will ensure that all
                of your Permitted Users agree to comply with the terms of this
                EULA and have been notified of and consented to TREND’s
                collection, use, and sharing of their personal information in
                accordance with the terms of TREND’s Privacy Policy before
                providing your Permitted Users with access to the Software. All
                references to “you” or “your” in this EULA shall also be
                construed to refer to your Permitted Users. You are responsible
                for: (a) identifying and authenticating all Permitted Users; (b)
                approving access by such Permitted Users to the Software; (c)
                ensuring Permitted Users’ compliance with this EULA; (d)
                controlling against unauthorised access or use by Permitted
                Users; (e) maintaining the confidentiality of user names,
                passwords and account information; and (f) providing or
                obtaining any necessary notifications or consents from Permitted
                Users as required by applicable law, including without
                limitation before activating the location tracking feature on
                the Tools. TREND is not responsible for any harm caused by your
                Permitted Users, including individuals who were not authorised
                to have access to the Software but who were able to gain access
                because user names, passwords or accounts were not terminated on
                a timely basis in your local identity management infrastructure,
                your local devices, or otherwise by you or on your behalf. You
                are responsible for all activities that occur under or in
                connection with your and your Permitted Users’ user names,
                passwords or accounts or as a result of your or your Permitted
                Users’ access to the Software and agree to notify TREND
                immediately in writing of any unauthorised use. You agree to
                make every reasonable effort to prevent unauthorised third
                parties from accessing the Software. You shall be liable for all
                acts and omissions of any Permitted User and shall indemnify
                TREND against all costs, expenses, claims, loss or damage
                incurred or suffered by TREND, or for which TREND may become
                liable, (whether direct, indirect or consequential and including
                any economic loss or other loss of profits, business or
                goodwill) arising out of any act or omission of any Permitted
                User.
              </li>
              <li>
                You must designate one or more Permitted User as an
                administrator (Administrator) of your account. You agree that
                the Administrator may, on your behalf, grant and revoke the
                access and use rights of other Permitted Users, at any time and
                for any reason. You may change your Administrator(s) at any time
                and for any reason by updating your designation.
              </li>
              <li>
                You agree that you are solely responsible for (and that TREND
                has no responsibility to you or to any third party for) your use
                of the Software, any breach of your obligations under this EULA,
                and for the consequences (including any loss or damage which
                TREND may suffer) of any such breach.
              </li>
              <li>
                You may access the Software on your devices using a web browser.
                A standalone version may be downloaded and installed on a PC
                running Microsoft Windows. The standalone version allows
                communication with the Tools via direct connection, not through
                the internet.
              </li>
              <li>
                In order to download, install, activate, access or otherwise use
                the Software, you will be required to register for an account.
                TREND reserves the right, in its sole and absolute discretion,
                to refuse any registration. In consideration of your use of the
                Software, you agree to: (i) provide accurate, current and
                complete account information; (ii) maintain and promptly update
                your account information; (iii) maintain the security of your
                password(s) and accept all risks of unauthorised access to your
                account and the information you provide to TREND; and (iv)
                promptly notify us if you discover or otherwise suspect any
                security breaches related to the Software or your use of it.
              </li>
              <li>
                To enable TREND to undertake service, maintenance and support of
                the Software, you shall grant to TREND such access as TREND
                shall require to enable TREND to log in to your account and
                operate your account as if operated by you. Such authorised
                access includes the right for TREND to view, modify and delete
                your data.
              </li>
              <li>
                To the extent permitted by law, TREND may delete any of your
                data to the extent any act or omission by you is not in
                compliance with this EULA. TREND will attempt to notify you
                prior to the deletion of your data, but shall not be in breach
                of this EULA if it fails to do so. If you download your data and
                delete it from our, or our third party, servers, such downloaded
                and deleted data will no longer be accessible via the Software
                or our, or our third party, servers.
              </li>
              <li>
                You are solely responsible for providing and maintaining at your
                own expense all tools, equipment, software, services, and other
                items necessary to use the Software and the Tools (including
                without limitation any computer or device hardware or software,
                modems, telephone service, and Internet access).
              </li>
              <li>
                You acknowledge that your use of the Software may require an
                internet connection and that you may incur data charges related
                to information transmitted (whether sent or received) by your
                device while using the Software. You are solely responsible for
                any such data charges.
              </li>
            </ol>
          </li>

          <li>
            <b>RESERVATION OF RIGHTS AND OWNERSHIP</b>
            <ol>
              <li>
                The Software is licensed, not sold, to you for use only in
                accordance with the terms of this EULA. Title, ownership and all
                rights in and to: (i) the Software (including without limitation
                all intellectual property rights); and (ii) all content and
                other materials therein provided by TREND or our third-party
                licensors, including, without limitation, the TREND and TREND
                AnyWARE® logos and all designs, text, graphics, pictures,
                information, data, software, sound files, other files and the
                selection and arrangement thereof (collectively Content), are
                the proprietary property of TREND or our licensors, as
                applicable, and are protected by copyright and other
                intellectual property rights and applicable laws and shall
                remain with TREND. TREND reserves all rights not expressly
                granted to you in this EULA and no other rights are granted,
                whether express or implied.
              </li>
              <li>
                “TREND”,“TREND Networks”, “TREND AnyWARE”, “LanTEK”, “TREND
                Networks”, “FiberTEK”, “SignalTEK”, “NaviTEK”, “SecuriTEST”,
                “LanXPLORER”, “UniPRO MGig1” and the TREND Networks and TREND
                AnyWARE® logos and any other TREND product or service names,
                logos or slogans that may appear in or on the Software or
                Content are trade marks of TREND, and neither they, nor any
                confusingly similar names logos or slogans, may be copied,
                imitated or used, in whole or in part, without the prior written
                permission of TREND. Third party marks appearing in or on the
                Software or Content are owned by third parties and may not be
                used without the permission of the relevant trade mark holder.
                You may not use any metatags or other “hidden text” utilising
                “TREND” or any other name, trade mark or product or service name
                of TREND without our prior written permission. In addition, the
                look and feel of the Software, including all page headers,
                custom graphics, button icons and scripts, are the service mark,
                trade mark and/or trade dress of TREND and may not be copied,
                imitated or used, in whole or in part, without our prior written
                permission. Reference to any products, services, processes or
                other information, by name, trade mark, manufacturer, supplier
                or otherwise does not constitute or imply endorsement,
                sponsorship or recommendation of the same by TREND.
              </li>
            </ol>
          </li>

          <li>
            <b>RESTRICTIONS AND LIMITATIONS</b>
            <ol>
              <li>
                You understand and agree that you shall only use the Software in
                a manner that complies with all applicable laws in jurisdiction
                where you use the Software. If you breach this EULA, you may be
                subject to prosecution and damages.
              </li>
              <li>
                You will not and will not permit any third party to:
                <ol>
                  <li>
                    download,install, activate, access or otherwise use the
                    Software or Content on any device you do not own or lawfully
                    control;
                  </li>
                  <li>
                    publish, discuss, release, broadcast or otherwise
                    disseminate to any third party, the results of any test
                    results obtained from the use of the Tools;
                  </li>
                  <li>
                    translate, merge, adapt, vary, alter or modify , the whole
                    or any part of the Software nor permit any part of it to be
                    combined with, or become incorporated in, any other
                    programs;
                  </li>
                  <li>
                    reverse engineer, decompile, attempt to derive the source
                    code of, modify or disassemble, the whole or any part of,
                    the Software, except and only to the extent that such
                    activity is expressly permitted by applicable law;
                  </li>
                  <li>
                    remove or alter any proprietary notices or marks on the
                    Software;
                  </li>
                  <li>
                    create derivative works based on the whole or any part of
                    the Software;
                  </li>
                  <li>
                    copy or reproduce the Software outside your organisation;
                  </li>
                  <li>
                    sell, assign, licence, distribute, rent, lease, sub-licence,
                    lend or provide or otherwise make available the Software, in
                    any form, in whole or in part to any person without TREND’s
                    prior written consent;
                  </li>
                  <li>
                    use the Software in any unlawful manner, for any unlawful
                    purpose, or in any manner inconsistent with these terms, or
                    act fraudulently or maliciously, for example, by hacking
                    into or inserting malicious code, such as viruses, or
                    harmful data, into the Software or any operating system;
                  </li>
                  <li>
                    infringe our intellectual property rights or those of any
                    third party in relation to your use of the Software,
                    including by the submission of any material (to the extent
                    that such use is not licensed by these terms);
                  </li>
                  <li>
                    transmit any material that is defamatory, offensive or
                    otherwise objectionable in relation to your use of the
                    Software;
                  </li>
                  <li>
                    use the Software in any manner that could damage, disable,
                    overburden, or impair the Software (or servers or networks
                    connected to the Software);
                  </li>
                  <li>
                    use the Software in any manner that may interfere with
                    another person’s use and enjoyment of the Software (or
                    servers or networks connected to the Software);
                  </li>
                  <li>
                    develop any third party applications that interact with the
                    Software without TREND’s prior written consent;
                  </li>
                  <li>
                    collect or harvest any information or data through your use
                    of the Software or TREND’s systems or attempt to decipher
                    any transmissions to or from the servers running the
                    Software; or
                  </li>
                  <li>
                    use the Software for purposes for which it was not designed
                    or intended or for any purpose other than as described
                    herein.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b>COLLECTION AND USE OF DATA</b>
            <ol>
              <li>
                You agree that TREND and its affiliates may collect and use
                technical information gathered as part of the product support
                services provided to you, if any, related to the Software. TREND
                may use this information solely to improve our products or to
                provide customised services or technologies to you and will not
                disclose this information in a form that personally identifies
                you.
              </li>
              <b class="subHeading">Personal Data</b>
              <li>
                You acknowledge that when you download, install, activate,
                access or otherwise use the Software, TREND may use automatic
                means (including, for example, cookies and web beacons) to
                collect information about your device and about your use of the
                Software. You and your Permitted Users may also be required to
                provide certain personal information as a condition to
                downloading, installing, activating, accessing or using the
                Software or certain of its features or functionality. Under data
                protection legislation, we are required to provide you with
                certain information about who we are, how we process your
                personal data and for what purposes and your rights in relation
                to your personal data and how to exercise them. This information
                is provided in TREND’s privacy policy, which is located at
                <a
                  href="https://www.trend-networks.com/US/EN/Privacy-Policy.aspx"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/US/EN/Privacy-Policy.aspx
                  </b>
                </a>
                , which may be updated from time to time without notice
                <b> (Privacy Policy)</b> and it is important that you read the
                Privacy Policy. By downloading, installing, activating,
                accessing or using the Software and providing information to or
                through the Software, you consent to all use and actions taken
                by TREND with respect to your information pursuant to the
                Privacy Policy.
              </li>
              <li>
                Please be aware that internet transmissions are never completely
                private or secure and that any message or information you send
                using the Software may be read or intercepted by others, even if
                there is a special notice that a particular transmission is
                encrypted.
              </li>
              <b class="subHeading">End User Data </b>
              <li>
                In connection with the Software, TREND may collect and maintain
                data entered or uploaded by you or on your behalf via the
                Software, including but not limited to information related to
                your use of the Tools and the Permitted Users thereof{" "}
                <b>(End User Data).</b> You shall own all End User Data and
                agree that you are solely responsible for End User Data. TREND
                shall maintain all personal identifiable aspects of all End User
                Data as confidential pursuant to the Privacy Policy. All third
                parties authorised by TREND which may have access to the End
                User Data shall be under obligations of confidentiality and
                shall be required to comply with all relevant data protection
                legislation. You agree to and do hereby grant to TREND an
                irrevocable, perpetual, royalty free, transferrable and
                sublicensable right and licence to use, reproduce, modify,
                adapt, translate, disclose, commercialise, assign, convey, sell,
                lease, licence or transfer any End User Data, in whole or in
                part, to the extent that it does not contain any personal data.
                By uploading or transmitting End User Data using the Software,
                you represent and warrant that: (i) such End User Data is not
                subject to any third-party confidentiality obligations that
                would be breached by the use of such End User Data in accordance
                with the terms of this EULA; (ii) you own and control all of the
                rights to the End User Data that you create, upload or transmit
                or you otherwise have all necessary rights to create, upload or
                transmit such End User Data using the Software; (iii) the End
                User Data is accurate and not misleading or harmful in any
                manner; and (iv) the End User Data, and your use, uploading and
                transmitting thereof, does not and will not breach the terms of
                this EULA or any applicable law, rule or regulation.
                Notwithstanding any other terms of this EULA, TREND may at any
                time: (a) delete any End User Data and/or (b) suspend your
                account and access to the Software. You shall ensure that you
                retain copies of all End User Data uploaded, transmitted or
                submitted to TREND through the Software and TREND shall have no
                liability whatsoever to you for loss of any End User Data, nor
                any loss of use of the Software.
              </li>
              <b class="subHeading">TREND Data </b>
              <li>
                All information, including, but not limited to, data, analyses,
                measurements, reports, trends, and metrics, generated from,
                derived from, based on or related to End User Data (TREND Data)
                is the sole property of TREND. TREND has the right to use,
                collect, store, create, aggregate, mine, analyse, modify,
                commercialise, assign, convey, sell, lease, licence or transfer
                TREND Data in any form, for any purpose and in any manner.
              </li>
            </ol>
          </li>

          <li>
            <b>UPDATES</b>
            <ol>
              <li>
                TREND may modify the Software without notice, including but not
                limited to changing the functionality or appearance of the
                Software.
              </li>
              <li>
                TREND may from time to time in its sole discretion develop and
                provide Software updates, which may include upgrades, bug fixes,
                patches and other error corrections and/or new features
                (collectively, including related documentation, <b>"Updates"</b>
                ). Updates may also modify or delete in their entirety certain
                features and functionality. You agree that TREND has no
                obligation to provide any Updates or to continue to provide or
                enable any particular features or functionality. Based on your
                device settings, when your device is connected to the Internet
                either: (i) the Software will automatically download and install
                all available Updates; or (ii) you may receive notice of or be
                prompted to download and install available Updates. In order to
                be able to fully utilise the Software, you must promptly
                download and install all Updates. You acknowledge that the
                Software or portions thereof may not properly operate should you
                fail to do so. You further agree that all Updates will be deemed
                part of the Software and be subject to all terms and conditions
                of this EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> LINKS TO THIRD PARTY SITES AND SUPPORT</b>
            <ol>
              <li>
                You may link to third party sites through the use of the
                Software (for example to “Team Viewer”, a remote desktop support
                platform and external label printer). The third party sites are
                not under the control of TREND, and TREND is not responsible for
                the contents of any third party sites, any links contained in
                third party sites, or any changes or updates to third party
                sites. TREND is not responsible for webcasting or any other form
                of transmission received from any third party sites. TREND is
                providing these links to third party sites to you only as a
                convenience, and the inclusion of any link does not imply an
                endorsement by TREND of the third party site.
              </li>
              <li>
                If you want to learn more about the Software or have any
                problems using it please visit{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                for regional email and telephone contact details. TREND will not
                be required to provide any support services under this EULA. If
                any support is required by you, this may be provided upon
                request on a time and cost basis. This EULA does not give you
                any rights to any updates or upgrades to the Software or to any
                extensions or enhancements to the Software developed by or on
                behalf of TREND at any time in the future. TREND may offer
                support services separately. Any supplemental software code or
                related materials that TREND provides to you as part of any
                support services are to be considered part of the Software and
                are subject to the terms and conditions of this EULA.
              </li>
            </ol>
          </li>

          <li>
            <b>CONFIDENTIAL INFORMATION</b> <br />
            You acknowledge and agree that the Software (excluding any Open
            Source Software) and all information emanating from the Software and
            TREND’s business in any form are valuable intellectual property of
            TREND and are considered TREND’s confidential information{" "}
            <b>(Confidential Information).</b>
            You agree that you will not, during or after the term of this EULA,
            permit the duplication, use, or disclosure of any such Confidential
            Information to any person, unless such duplication, use or
            disclosure is specifically authorised by TREND in writing prior to
            any disclosure. You shall use reasonable diligence, and in no event
            less than that degree of care that you use in respect to your own
            confidential information of like nature, to prevent the unauthorised
            disclosure or reproduction of the Confidential Information. Without
            limiting the generality of the foregoing, to the extent that this
            EULA permits the copying of Confidential Information, all such
            copies shall bear the same confidentiality notices, legends, and
            intellectual property rights designations that appear in the
            original versions and you shall keep detailed records of the
            location of all Confidential Information.
          </li>

          <li>
            <b>RIGHT TO TERMINATE EULA</b>
            <ol>
              <li>
                This EULA will continue to apply until terminated by either you
                or TREND as stated herein.
              </li>
              <li>
                You may terminate this EULA at any time by ceasing to access the
                Software and/or permanently uninstalling the Software from your
                computer in its entirety.
              </li>
              <li>
                Your rights automatically and immediately terminate without
                notice from TREND if you fail to comply with any provision of
                this EULA. In such event, you must immediately stop accessing
                the Software and/or uninstall the Software.
              </li>
              <li>
                TREND may terminate your right to use the Software at any time,
                with or without notice. The terms of this EULA related to use of
                data, indemnification, limitation of liability, confidentiality,
                dispute resolution and agreement construction and formation
                survive termination or expiration of this EULA.
              </li>
            </ol>
          </li>

          <li>
            <b>INDEMNIFICATION </b>
            <br />
            To the maximum extent permitted by law, you agree to defend,
            indemnify and hold harmless TREND, its subsidiaries and affiliates
            and their respective directors, officers, employees and agents from
            and against any and all claims, actions, suits or proceedings, as
            well as any and all losses, liabilities, damages, costs and expenses
            (including reasonable attorney’s fees) arising out of or accruing
            from your (or anyone acting under your account or password) use of
            the Software, including your access and/or installation or use of
            the Software, or your violation of this EULA.
          </li>

          <li>
            <b>LIMITATION OF LIABILITY</b>
            <ol>
              <li>
                TREND DOES NOT EXCLUDE OR LIMIT IN ANY WAY ITS LIABILITY TO YOU
                WHERE IT WOULD BE UNLAWFUL TO DO SO. THIS INCLUDES LIABILITY FOR
                DEATH OR PERSONAL INJURY CAUSED BY TREND’S NEGLIGENCE OR THE
                NEGLIGENCE OF ITS EMPLOYEES, AGENTS OR SUBCONTRACTORS OR FOR
                FRAUD OR FRAUDULENT MISREPRESENTATION.
              </li>
              <li>
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE SOFTWARE
                IS AT YOUR SOLE DISCRETION AND RISK AND THAT THE SOFTWARE IS
                PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTY OF ANY
                KIND, EITHER EXPRESS OR IMPLIED. YOU ARE SOLELY RESPONSIBLE FOR
                ANY DAMAGE TO YOUR COMPUTER, OR OTHER DEVICE, OR LOSS OF DATA
                THAT RESULTS FROM SUCH USE. TREND FURTHER EXPRESSLY DISCLAIMS
                ALL OTHER WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS
                OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES
                AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE AND NON-INFRINGEMENT, WITH RESPECT TO THE SOFTWARE. SOME
                JURISDICTIONS DO NOT ALLOW THE WAIVER OR EXCLUSION OF IMPLIED
                WARRANTIES SO THEY MAY NOT APPLY TO YOU. TREND DOES NOT WARRANT
                AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF THE SOFTWARE, THAT
                THE FUNCTIONS CONTAINED IN, OR SERVICES PERFORMED OR PROVIDED BY
                THE SOFTWARE WILL MEET YOUR REQUIREMENTS, THAT THE OPERATION OF
                THE SOFTWARE OR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, OR
                THAT DEFECTS IN THE SOFTWARE OR SERVICES WILL BE CORRECTED. NO
                ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY TREND OR ITS
                AUTHORISED REPRESENTATIVES SHALL CREATE A WARRANTY.
              </li>
              <li>
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT, EXCEPT WITH RESPECT TO
                SECTION 10.1, TREND, ITS SUBSIDIARIES AND AFFILIATES, AND ITS
                LICENSORS SHALL HAVE NO LIABILITY TO YOU FOR ANY LOSS OR DAMAGES
                OF WHATSOEVER NATURE OR AMOUNT, UNDER ANY THEORY OF LIABILITY,
                WHETHER OR NOT SUCH LOSS OR DAMAGES ARE DIRECT, INDIRECT,
                INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, AND
                WHETHER OR NOT SUCH LOSS OR DAMAGES ARE SUFFERED OR INCURRED BY
                YOU THROUGH YOUR USE OF THE SOFTWARE, INCLUDING ANY LOSS OF DATA
                OR DAMAGE TO YOUR DEVICES, AND WHETHER OR NOT YOU OR YOUR
                REPRESENTATIVES HAVE BEEN ADVISED OF OR SHOULD HAVE BEEN AWARE
                OF THE POSSIBILITY OF ANY SUCH LOSSES ARISING.
              </li>
              <li>
                PLEASE BACK-UP CONTENT AND DATA USED WITH THE SOFTWARE. TREND
                RECOMMENDS THAT YOU BACK UP ANY CONTENT AND DATA USED IN
                CONNECTION WITH THE SOFTWARE, TO PROTECT YOURSELF IN CASE OF
                PROBLEMS WITH THE SOFTWARE.
              </li>
            </ol>
          </li>

          <li>
            <b> CHANGES TO THE EULA </b>
            <br />
            At any time, by notice to you (whether by email, on-line, through
            the Software or otherwise) specifying the amendment, TREND may amend
            the EULA (including an amendment as to the fees payable by you for
            use of the Software) and such amendment shall be deemed effective
            within thirty (30) days from the date of such notice. You shall
            acknowledge and agree such amendments, as specified in the notice.
            Failure to acknowledge and agree such amendments shall entitle TREND
            to terminate this EULA upon one (1) month’s notice to you.
          </li>

          <li>
            <b>NOTICES </b>
            <ol>
              <li>
                Any notice or other communication given to a party under or in
                connection with this EULA shall be in writing and shall be
                delivered by hand or by pre-paid first-class post or other next
                working day delivery service at its registered office (if a
                company) or its principal place of business (in any other case).
              </li>
              <li>
                Any notice or communication shall be deemed to have been
                received: (i) if delivered by hand, on signature of a delivery
                receipt or at the time the notice is left at the proper address;
                (ii) if sent by pre-paid first-class post or other next working
                day delivery service, at 9.00 am on the second business day
                after posting or at the time recorded by the delivery service;
                and (iii) if sent by email, at the time of transmission, or, if
                this time falls outside business hours in the place of receipt,
                when business hours resume (being 9.00am to 5.00pm Monday to
                Friday on a day that is not a public holiday in the place of
                receipt).
              </li>
            </ol>
          </li>

          <li>
            <b>GOVERNING LAW AND JURISDICTION </b>
            This EULA and any dispute or claim (including non-contractual
            disputes or claims) arising out of or in connection with it or its
            subject matter or formation shall be governed by and construed in
            accordance with the law of England and Wales and each party
            irrevocably agrees that the courts of England and Wales shall have
            exclusive jurisdiction to settle any dispute or claim (including
            non-contractual disputes or claims) arising out of or in connection
            with this EULA or its subject matter or formation.
          </li>

          <li>
            <b>MISCELLANEOUS</b>
            <br />
            This EULA (including any addendum or amendment to this EULA) is the
            entire agreement between you and TREND relating to the Software and
            the support services (if any) and it supersedes all prior or
            contemporaneous oral or written communications, proposals and
            representations with respect to the Software or any other subject
            matter covered by this EULA. To the extent the terms of any TREND
            policies or terms for support services conflict with the terms of
            this EULA, the terms of this EULA shall control. If any provision of
            this EULA is held to be void, invalid, unenforceable or illegal,
            such provision will be deemed to be restated to reflect the original
            intention of the parties to the maximum extent possible and in
            accordance with applicable law and the other provisions shall
            continue in full force and effect. TREND’s failure to exercise or
            enforce any right or provision of this EULA shall not constitute a
            waiver of such right or provision unless acknowledged and agreed to
            by TREND in writing. Neither the course of conduct between the
            parties nor trade practice shall act to modify any provision of this
            EULA. You may not assign this EULA or any of your rights under this
            EULA without the prior written consent of TREND, which may be
            granted or conditioned in our sole and absolute discretion, and any
            attempted assignment without such consent shall be null and void.
            Subject to the foregoing restriction, this EULA will be fully
            binding upon, inure to the benefit of, and be enforceable by TREND
            and our respective successors and assigns. TREND may transfer its
            rights and obligations under these terms to another organisation.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/components/englishUs.js